export class Token {
  userIds: Record<string, string> = {};
  accessToken: string | null = "";
  refreshToken: string | null = "";
}
